import trim from 'lodash/trim';

const trunc = (str, len) => {
  const s = trim(str);

  if (s.length <= len) {
    return s;
  }

  return `${trim(s.substring(0, len))}…`;
};
const formatPermillage = (string) =>( String(string).replace(/(\d)(?=(\d{3})+$)/g, "$1,"))

export {
  trunc,
  formatPermillage
};



// WEBPACK FOOTER //
// ./src/misc/strings.js